import { create } from 'zustand'
import type { ChatSocketState } from '@olmt/shared'

interface UiState {
  socketState: ChatSocketState
  /** Chat currently open in the thread pane; drives read receipts and unread suppression. */
  activeChatId: string | null
  setSocketState: (state: ChatSocketState) => void
  setActiveChatId: (chatId: string | null) => void
}

export const useUiStore = create<UiState>()((set) => ({
  socketState: 'idle',
  activeChatId: null,
  setSocketState: (socketState) => set({ socketState }),
  setActiveChatId: (activeChatId) => set({ activeChatId }),
}))
